import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';

import { Router } from '@angular/router';
import { Subscription, takeWhile, timer } from 'rxjs';
import { MiddlemanService } from '../../auth/services/Middleman.service';
import { PendingComponent } from '../pending/pending.component';
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, PendingComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnDestroy {

public display = true
  public displayspinner = true
  private subscription: Subscription
  constructor(protected router: Router, private _nextclear: MiddlemanService) {
    this.subscription = this._nextclear.notifyredirectObservable$.subscribe(
      (res) => {
        const splitvalue = res.split('|')
        const rolesplit = splitvalue[0]
        if (rolesplit.toUpperCase() === 'ADVISOR USER'.toUpperCase()) {
          this.display = false
          this.displayspinner = true
          return location.replace('/pages/advisors/AdvisorClients') // this.router.navigate(['pages/advisors/AdvisorClients'])
        }
        if (rolesplit.toUpperCase() === 'HOME OFFICE USER'.toUpperCase()) {
          this.display = false
          this.displayspinner = true
          return location.replace('/pages/view-reps/default') // this.router.navigate(['pages/view-reps/default'])
        }
        if (rolesplit.toUpperCase() === 'REP DATA'.toUpperCase()) {
          this.display = false
          this.displayspinner = true
          return location.replace('/pages/view-reps/default') // this.router.navigate(['pages/view-reps/default'])
        } else {
          this.display = true
          this.displayspinner = false
          return
        }
      },
    )
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
    this.display = false
  }
  getRoleDirction() {
    timer(3000)
      .pipe(takeWhile(() => this.display))
      .subscribe((_) => {
        this.router.navigate(['/pages/advisors/AdvisorClients'])
      })
  }
}
